import { PlaneCreate } from '~/modules/sites';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

export default dashboardWrapper(PlaneCreate, t('menu.dashboard.settingsSites'));
